const UnnamedComponent = (props) => {
  return <img {...props} loading="lazy" />;
};

export default UnnamedComponent;
